<template>
    <input style="width:100%" type="text" v-model="value" @input="handleInput" :name="name" v-validate="validate" @focus="handleFocus" @blur="handleBlur">
</template>

<script>
  import $ from 'jquery';
  import 'suggestions-jquery';

  export default {
    inject: ['$validator'],
    props: {
      validate:null,
      name:null,
      model: {
        required: true,
      },
      coordinates: {},
      options: {
        type: Object,
        default: {
          type: 'ADDRESS',
          addon: 'none'
        }
      }
    },
    data() {
      return {
        value: '',
        coords: {
          latitude: '',
          longitude: ''
        },
      }
    },
    mounted() {
      this.callbacks = $.Callbacks();
      this.value = this.model;
      this.initSuggestion();
    },
    destroyed() {
      this.destroySuggestion();
    },
    watch: {
      coords: {
        handler() {
          this.$emit('update:coordinates', this.coords);
        },
        deep: true
      },
      value() {
        this.$emit('update:model', this.value);
      },
      model() {
        this.value = this.model;
      }
    },
    methods: {
      initSuggestion() {
        this.callbacks.add(this.onSelect);
        this.callbacks.add(this.options.onSelect || $.noop)
        const options = Object.assign({}, this.options, {
          onSelect: suggestion => this.callbacks.fire(suggestion)
        });
        $(this.$el).suggestions(options);
      },
      destroySuggestion() {
        const plugin = $(this.$el).suggestions();
        plugin.dispose();
      },
      onSelect(suggestion) {
        this.value = suggestion.value;
        const { geo_lat, geo_lon } = suggestion.data;
        this.coords.latitude = geo_lat;
        this.coords.longitude = geo_lon;
      },
      handleFocus(){
        this.$emit('focus');
      },
      handleBlur(){
        this.$emit('blur');
      },
      handleInput(e){
        this.$emit('handleInput', e);
      }
    }
  };
</script>
<style lang="scss">
  .suggestions-wrapper {
    svg {
      display: none !important;
    }
  }
  .suggestions-hint {
    display: none;
  }
  .suggestions-constraints {
    display: none;

  }
  .suggestions-suggestions {
    top:5px !important;
  }
  .suggestions-suggestion {
    padding: 2px 5px 2px 5px !important;
    font-size: 14px !important;
    background: none;
    list-style: none;
    margin: 0;
    text-transform: uppercase;
    color: #009ca6;
    font-weight: 300;
  
    &:hover {
      background-color: #b9e5e5;
    }
  }
  .ui-autocomplete .ui-menu-item {
    
  }
</style>
